import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sortButton", "sortLabel"];

  connect() {
    this.updateSortState();
  }

  toggleSort() {
    this.updateSortState();
    this.submitForm();
  }

  resetSort() {
    const inputs = this.sortInputs();

    inputs.forEach((i) => (i.checked = false));

    this.defaultInputs(inputs).forEach((i) => (i.checked = true));

    this.updateSortState();
    this.submitForm();
  }

  sortInputs() {
    return Array.from(
      this.element.querySelectorAll(
        'input[type="radio"][data-filter-type="sort"][data-filter-group]'
      )
    );
  }

  defaultInputs(inputs = this.sortInputs()) {
    return inputs.filter((i) => i.dataset.filterDefault === "true");
  }

  sortApplied(inputs = this.sortInputs()) {
    const groups = new Map();

    for (const input of inputs) {
      const group = input.dataset.filterGroup;
      if (!group) continue;

      const state = groups.get(group) || { defaultValue: null, selectedValue: null };

      if (input.dataset.filterDefault === "true") {
        state.defaultValue = input.dataset.filterValue ?? "";
      }
      if (input.checked) {
        state.selectedValue = input.dataset.filterValue ?? "";
      }

      groups.set(group, state);
    }

    for (const { defaultValue, selectedValue } of groups.values()) {
      const current = selectedValue ?? "";
      const applied = defaultValue === null ? Boolean(current) : current !== defaultValue;
      if (applied) return true;
    }

    return false;
  }

  updateSortState() {
    if (!this.hasSortButtonTarget) return;

    const applied = this.sortApplied();
    const baseLabel = this.sortButtonTarget.dataset.sortLabel || "";

    this.sortButtonTarget.classList.toggle("bg-blue-gray-100", applied);

    if (this.hasSortLabelTarget) {
      this.sortLabelTarget.textContent = baseLabel;
    }
  }

  submitForm() {
    const form = this.element.closest("form");
    if (!form) return;

    form.requestSubmit ? form.requestSubmit() : form.submit();
  }
}
